export enum View {
  Grid,
  List,
  Detail,
}
